import { useToast } from '@shared/components/toast';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { LoadShipmentForm } from '@shared/features/load-shipment-form';
import {
  SidekickSupportedTms,
  useFindShipmentLazyQuery,
} from '@shared/generated/graphql';
import { useOrganizationFeatureFlag } from '@shared/hooks/useOrganizationFeatureFlag';
import { useNavigateWithReturn } from '@shared/plugin/hooks/useReturnRoute';
import { SHIPMENTS_ROUTE } from 'clerk_common/constants/urls/routes';
import { FeatureFlagName } from 'clerk_common/types';

export const NavigateToShipment = () => {
  const { sendToast } = useToast();
  const navigateWithReturn = useNavigateWithReturn();
  const { defaultOrgId } = useMeContext();
  const [findShipment] = useFindShipmentLazyQuery();

  const isLoadShipmentByIdEnabled = useOrganizationFeatureFlag({
    featureFlagName: FeatureFlagName.LOAD_SHIPMENT_BY_ID,
  });

  if (!isLoadShipmentByIdEnabled) return null;

  const loadShipmentByReference = (referenceNumber: string) => {
    const sendErrorToast = () => {
      sendToast('Unable to find shipment', {
        variant: 'error',
        autoHideDuration: 3000,
        isDismissible: true,
      });
    };

    findShipment({
      variables: {
        input: {
          organizationId: defaultOrgId ?? '',
          referenceNumber,
          tms: SidekickSupportedTms.UNKNOWN,
        },
      },
    })
      .then((result) => {
        const shipmentId = result.data?.findShipment.shipmentId;
        if (shipmentId) {
          navigateWithReturn(`${SHIPMENTS_ROUTE}/${shipmentId}`);
        } else {
          sendErrorToast();
        }
      })
      .catch(sendErrorToast);
  };

  return (
    <div className="flex justify-center bg-white">
      <LoadShipmentForm setShipmentReference={loadShipmentByReference} />
    </div>
  );
};
